import { Warning } from '@mui/icons-material'
import { SvgIcon, useTheme } from '@mui/material'

import { Switch } from 'features/alerts/components/Alerts/types'
import { WorkspaceAlert } from 'features/workspace/types/workspaceAlert'
import SignalDisconnected from 'images/icons/signal-disconnected.svg?react'
import { GAM_NOT_CONNECTED_URL } from './constants'

type UseAlerts = {
  switcher: Switch<WorkspaceAlert>
}

export const useAlerts = (): UseAlerts => {
  const theme = useTheme()

  const switcher: UseAlerts['switcher'] = alert => {
    switch (alert.name) {
      case 'gamNotConnected':
        return {
          color: theme.palette.error.main,
          Icon: (
            <SvgIcon
              component={SignalDisconnected}
              inheritViewBox
            />
          ),
          tooltip: {
            link: GAM_NOT_CONNECTED_URL,
            text: alert.description,
          },
        }
      case 'inactive':
        return {
          color: theme.palette.warning.main,
          Icon: <Warning data-cy='warning-icon' />,
          tooltip: {
            text: alert.description,
          },
        }
      default:
        throw Error('Missing alert config')
    }
  }

  return { switcher }
}
